// extracted by mini-css-extract-plugin
export default {"modal":"TermOfUseModal_modal__bnz+2","title":"TermOfUseModal_title__x-okP","closeButton":"TermOfUseModal_closeButton__kht5J"};